/* eslint-disable @typescript-eslint/naming-convention */
export class ExternalTransferResponseDto {
	public Erros: string[];
	public Data: string;
}
